import { ParametersBuilder1ry9ntvvg567r as ParametersBuilder } from './Parameters.mjs';
import { appendAlltwnjnu28pmtx as appendAll } from '../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { joinTo3lkanfaxbzac2 as joinTo } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  URLBuilder2mz8zkz4u9ray as URLBuilder,
  set_encodedPath3q0i8nsv3a7qy as set_encodedPath,
} from './URLBuilder.mjs';
import { takeFrom3rd40szpqy350 as takeFrom } from './URLParser.mjs';
import { parseQueryString1nwcni3n22i7m as parseQueryString } from './Query.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function takeFrom_0(_this__u8e3s4, url) {
  _this__u8e3s4.u54_1 = url.u54_1;
  _this__u8e3s4.r54_1 = url.r54_1;
  _this__u8e3s4.z55(url.t54_1);
  _this__u8e3s4.y54_1 = url.y54_1;
  _this__u8e3s4.v54_1 = url.v54_1;
  _this__u8e3s4.w54_1 = url.w54_1;
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAll(this_0, url.z54_1);
  _this__u8e3s4.m56(this_0);
  _this__u8e3s4.x54_1 = url.x54_1;
  _this__u8e3s4.s54_1 = url.s54_1;
  return _this__u8e3s4;
}
function Url(urlString) {
  return URLBuilder_0(urlString).p37();
}
function appendUrlFullPath(_this__u8e3s4, encodedPath, encodedQueryParameters, trailingQuery) {
  var tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  if (!isBlank(encodedPath)) {
    tmp = !startsWith(encodedPath, '/');
  } else {
    tmp = false;
  }
  if (tmp) {
    _this__u8e3s4.o1(_Char___init__impl__6a9atx(47));
  }
  _this__u8e3s4.o2(encodedPath);
  if (!encodedQueryParameters.n1() || trailingQuery) {
    _this__u8e3s4.o2('?');
  }
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = encodedQueryParameters.e4p();
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList().p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var key = element.m3();
    // Inline function 'kotlin.collections.component2' call
    var value = element.n3();
    var tmp_0;
    if (value.n1()) {
      tmp_0 = listOf(to(key, null));
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList().h2(collectionSizeOrDefault(value, 10));
      var _iterator__ex2g4s_0 = value.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var item = _iterator__ex2g4s_0.r1();
        var tmp$ret$8 = to(key, item);
        destination_0.i2(tmp$ret$8);
      }
      tmp_0 = destination_0;
    }
    var list = tmp_0;
    addAll(destination, list);
  }
  var tmp_1 = destination;
  joinTo(tmp_1, _this__u8e3s4, '&', VOID, VOID, VOID, VOID, appendUrlFullPath$lambda);
}
function appendUserAndPassword(_this__u8e3s4, encodedUser, encodedPassword) {
  if (encodedUser == null) {
    return Unit_instance;
  }
  _this__u8e3s4.m1(encodedUser);
  if (!(encodedPassword == null)) {
    _this__u8e3s4.o1(_Char___init__impl__6a9atx(58));
    _this__u8e3s4.m1(encodedPassword);
  }
  _this__u8e3s4.m1('@');
}
function URLBuilder_0(urlString) {
  return takeFrom(new (URLBuilder())(), urlString);
}
function get_hostWithPortIfSpecified(_this__u8e3s4) {
  var tmp0_subject = _this__u8e3s4.f55_1;
  return tmp0_subject === 0 || tmp0_subject === _this__u8e3s4.q55_1.c55_1 ? _this__u8e3s4.e55_1 : get_hostWithPort(_this__u8e3s4);
}
function get_hostWithPort(_this__u8e3s4) {
  return _this__u8e3s4.e55_1 + ':' + _this__u8e3s4.u56();
}
function URLBuilder_1(url) {
  return takeFrom_1(new (URLBuilder())(), url);
}
function takeFrom_1(_this__u8e3s4, url) {
  _this__u8e3s4.u54_1 = url.p55_1;
  _this__u8e3s4.r54_1 = url.e55_1;
  _this__u8e3s4.z55(url.u56());
  set_encodedPath(_this__u8e3s4, url.v56());
  _this__u8e3s4.v54_1 = url.w56();
  _this__u8e3s4.w54_1 = url.x56();
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  this_0.p4p(parseQueryString(url.y56(), VOID, VOID, false));
  _this__u8e3s4.m56(this_0);
  _this__u8e3s4.x54_1 = url.z56();
  _this__u8e3s4.s54_1 = url.k55_1;
  return _this__u8e3s4;
}
function appendUrlFullPath$lambda(it) {
  var key = it.ue_1;
  var tmp;
  if (it.ve_1 == null) {
    tmp = key;
  } else {
    var value = toString(it.ve_1);
    tmp = key + '=' + value;
  }
  return tmp;
}
//region block: exports
export {
  URLBuilder_0 as URLBuilder1nlnzfhn643pn,
  URLBuilder_1 as URLBuilder1hwx1b9569i61,
  Url as Urlowwyg1lanrqp,
  appendUrlFullPath as appendUrlFullPath2slafmfwiwvmw,
  appendUserAndPassword as appendUserAndPassword2m6va0hoftk5,
  get_hostWithPortIfSpecified as get_hostWithPortIfSpecified1w0e2oq2yfcan,
  takeFrom_1 as takeFrom2oawu6chjqyp9,
  takeFrom_0 as takeFromkqlcz7c6dx2r,
};
//endregion

//# sourceMappingURL=URLUtils.mjs.map
